const initCurrencySwitcher = (): void => {
  const formWrappers = document.querySelectorAll('[data-currency-shopify-form-wrapper]');
  if (!formWrappers.length) return;

  formWrappers.forEach(wrapper => {
    const currencySwitcherDropdown: HTMLSelectElement = wrapper.querySelector('select');
    const currencyForm: HTMLFormElement = wrapper.querySelector('form');
    currencySwitcherDropdown.addEventListener('change', e => {
      e.preventDefault();

      currencyForm.submit();
    });
  });
}

export {
  initCurrencySwitcher
}